/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 7);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = es;

function es () {}

var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
var ObjProto = Object.prototype;
var property = function(key) {
  return function(obj) {
    return obj == null ? void 0 : obj[key];
  };
};
var getLength = property('length');

var isArrayLike = function(collection) {
  var length = getLength(collection);
  return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
};

es.isObject = function(obj) {
  var type = typeof obj;
  return type === 'function' || type === 'object' && !!obj;
};

es.has = function(obj, key) {
  return obj != null && ObjProto.hasOwnProperty.call(obj, key);
};

es.extend = function(obj) {
  var len = arguments.length;
  if (len < 2 || obj == null) return obj;
  var source, idx, k;
  for (idx = 1; idx < len; idx++) {
    source = arguments[idx];
    for (k in source) {
      if (es.has(source, k)) obj[k] = source[k];
    }
  }
  return obj;
};

es.keys = function(obj) {
  if (!es.isObject(obj)) return [];
  if (Object.keys) return Object.keys(obj);
  var keys = [];
  for (var key in obj) if (es.has(obj, key)) keys.push(key);
  return keys;
};

es.each = function(obj, func, context) {
  var iteratee = function() {
    return func.apply(context, arguments);
  };

  var i, length;
  if (isArrayLike(obj)) {
    for (i = 0, length = obj.length; i < length; i++) {
      iteratee(obj[i], i, obj);
    }
  } else {
    var keys = es.keys(obj);
    for (i = 0, length = keys.length; i < length; i++) {
      iteratee(obj[keys[i]], keys[i], obj);
    }
  }
  return obj;
};

es.each(['Function', 'String', 'Number', 'Date'], function(name) {
  es['is' + name] = function(obj) {
    return ObjProto.toString.call(obj) === '[object ' + name + ']';
  };
});

var _multiArgTypeCheck = function (type) {
  return function () {
    var i, len = arguments.length;
    for (i = 0; i < len; i++) {
      if (!es[type](arguments[i])) return false;
    }
    return true;
  };
};

es.inum = _multiArgTypeCheck('isNumber');

es.istr = _multiArgTypeCheck('isString');

// todo: need support ie 6-7 ?
es.stringify = function (json) {
  return JSON.stringify(json);
}

/***/ }),
/* 1 */
/***/ (function(module, exports) {

function getPerformanceData() {
  var t = performance.timing;
  var ts = {};

  // 页面加载完成的时间。 tab 上转菊花
  ts.pageload = t.loadEventEnd - t.navigationStart;

  // 解析 DOM 树结构的时间。 反省下你的 DOM 树嵌套是不是太多了！
  ts.dom = t.domComplete - t.responseEnd;

  // JS 脚本加载执行完毕，可以交互操作了
  ts.domready = t.domContentLoadedEventEnd - t.navigationStart;

  // DNS 查询时间
  // DNS 预加载做了么？页面内是不是使用了太多不同的域名导致域名查询的时间太长？
  // 可使用 HTML5 Prefetch 预查询 DNS
  // 见：[HTML5 prefetch](http://segmentfault.com/a/1190000000633364)
  ts.dns = t.domainLookupEnd - t.domainLookupStart

  // 首字节时间
  // TTFB 即 Time To First Byte 的意思
  // 加异地机房了么，加CDN 处理了么？加带宽了么？加 CPU 运算速度了么？
  ts.ttfb = t.responseStart - t.navigationStart;

  // 内容加载完成的时间
  // 页面内容经过 gzip 压缩了么，静态资源 css/js 等压缩了么？
  ts.request = t.responseEnd - t.requestStart;

  // 执行 onload 回调函数的时间
  // 是否太多不必要的操作都放到 onload 回调函数里执行了，考虑过延迟/按需加载的策略么？
  ts.onload = t.loadEventEnd - t.loadEventStart;

  return ts;
}

module.exports = function () {
 return getPerformanceData();
};

/***/ }),
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var es = __webpack_require__(0)
var cookie = __webpack_require__(8)

module.exports = utils;

function utils () {}

var
  ua = navigator.userAgent,
  isQB = /\bQQBrowser\b/i.test(ua),

  ext = window.external;

utils.isQB = isQB;

var parseUrlParams = utils.parseUrlParams = function (str) {
  str || (str = '');
  var vars = str.split("&");
  var json = {}, pair;

  for (var i = 0; i < vars.length; i++) {
    pair = vars[i].split('=');
    json[pair[0]] = decodeURIComponent(pair[1] || '');
  }
  return json
};

var getUrlParams = utils.getUrlParams = function (key) {
  var query = window.location.search.substring(1);
  var json = parseUrlParams(query);
  utils.getUrlParams = function (k) {
    return k ? json[k] : json;
  };
  return key ? json[key] : json;
};

var ls = function (k, v) {
  var isread = arguments.length === 1, _ls = window.localStorage;
  if (_ls) {
    return isread ? _ls.getItem(k) : _ls.setItem(k, v);
  }
  return isread ? cookie(k) : cookie(k, v, {expires: 365 * 3});
};

var createGuid = utils.createGuid = function () {
  return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0;
    var v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
};

utils.getGuid = (function () {
  var k = '_noqb_guid', guid = '';

  return function () {
    if (guid) return guid;

    if (isQB && ext && ext.getGuid && ext.getGuid()) {
      guid = ext.getGuid().replace(/-/g, '');
    } else {
      guid = ls(k);
      if (!guid) {
        guid = createGuid();
        ls(k, guid);
      }
    }
    return guid;
  }
})();

utils.imgsend = function (url, fn1, fn2) {
  var img = new Image();
  img.onload = function(){ es.isFunction(fn1) && fn1() };
  img.onerror = function(){ es.isFunction(fn2) && fn2() };
  // img.src = url + '&t=' + (new Date()).getTime();
  img.src = url + '&r=' + Math.random();
  img = null;
};

// 等待 performance.timing.loadEventEnd 计算完成
// 如果浏览器不支持 performance.timing，则不执行
utils.onLoadEventEnd = (function () {
  var queue = [], timerHandler;

  function _wait() {
    clearTimeout(timerHandler);
    if (!performance.timing.loadEventEnd) {
      timerHandler = setTimeout(function () { _wait() }, 300);
      return;
    }

    for (var i = 0; i < queue.length; i++) {
      queue[i]();
    }
    queue = null;
  }

  return (window.performance && performance.timing) ? function (fn) {
    if (performance.timing.loadEventEnd) {
      fn();
    } else {
      queue.push(fn);
      _wait();
    }
  } : function (fn) {}
})();

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var es = __webpack_require__(0);
var requireJS = __webpack_require__(10);

var url = 'http://pingjs.qq.com/tcss.ping.js';
var queue = [];
var state = 0;
var hasPV  = false;
var haswatched = false;

function loadTcssPing (cb) {
  if (state === 2) {
    return cb();
  }

  queue.push(cb);

  if (state === 1) return;

  state = 1;
  requireJS([url], function () {
    // 避免 tcss 的 pv 多次发送
    // 例如：运营活动页面用到 AMS 时，AMS 自带了 tcss 的 pv 统计，
    // 这会导致当前页面 pv 加倍
    window.__pgvmain = pgvMain;

    try {
      Object.defineProperty && Object.defineProperty(window, 'pgvMain', {
        configurable: false,
        writable: false,
        value: '[forbid tcss pv: ams, ...]'
      });
    } catch (e) {}

    state = 2;
    es.each(queue, function (fn) { fn() });
    queue = null;
  }, function () { state = 0 });
}

module.exports = {

  pv : function () {
    // 点击流的页面 pv 确保仅发送一次
    !hasPV && loadTcssPing(function () {
      __pgvmain && __pgvmain("pathtrace", {
        pathStart: true,
        tagParamName: "ADTAG",
        useRefUrl: true,
        override: true,
        careSameDomainRef: false,
        sessionSpan: 60
      });
    });

    hasPV = true;
  },

  click : function (key) {
    loadTcssPing(function () {
      pgvSendClick && pgvSendClick({hottag: key});
    });
  },

  watch: function (nodeId) {
    !haswatched && loadTcssPing(function () {
      document.attachEvent ? document.attachEvent("onclick", function(e) {
          pgvWatchClick(e);
      }) : document.addEventListener("click", function(e) {
          pgvWatchClick(e);
      }, false);
    });

    haswatched = true;
  }

};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

;(function(win) {

  if (win._qblog) return;

  var utils = __webpack_require__(5);
  var es = __webpack_require__(0);
  var wsd = __webpack_require__(9);
  var tcss = __webpack_require__(6);

  var __wsd = wsd({autopv: false, autoPerformance: false, isCustom: false});

  var qblog = {

    setting: function (confs, opts) {
      if (es.isObject(confs)) confs = [confs];

      es.each(confs, function (conf, idx) {
        var _conf = es.extend({}, wsd.default_conf, conf);
        var p = 'p' + _conf.protocol, k = 'k' + _conf.key;

        if (qblog[p] && qblog[k]) return;

        var w = wsd(_conf);
        // 第一个设置为默认
        if (idx === 0) qblog.wsd = w;
        // 快捷方式访问
        // qblog.p8888.k520.click('a.b.c')
        // qblog.k520.click('a.b.c')
        if (!qblog[p]) qblog[p] = {};
        qblog[p][k] = qblog[k] = w;
      });

      // 自动性能 performance.timing
      if (qblog.wsd && qblog.wsd.conf.autoPerformance) {
        qblog.wsd.performance();
      }
    },

    tcss: tcss,

    // -------------------------------------------------------------------------
    // 快捷访问的 API，便于老项目的逐步迁移

    fs: function (time, pname) {
      __wsd.fs(time, pname);
    },

    performance: function (pname) {
      __wsd.performance(pname);
    },

    track: function (opts, fn1, fn2) {
      opts.isCustom = true;
      __wsd.track(opts, fn1, fn2);
    }
  };

  win._qblog = qblog;

})(window);

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var es = __webpack_require__(0);

module.exports = function (key, value, options) {
  var days, time, result, decode, encode = encodeURIComponent;

  decode = options.raw ? function (s) { return s } : decodeURIComponent;

  // A key and value were given. Set cookie.
  if (arguments.length > 1 && String(value) !== "[object Object]") {
    // Enforce object
    options = es.extend({}, options)

    if (value === null || value === undefined) options.expires = -1

    if (typeof options.expires === 'number') {
      days = (options.expires * 24 * 60 * 60 * 1000)
      time = options.expires = new Date()

      time.setTime(time.getTime() + days)
    }

    value = String(value)

    return (document.cookie = [
      encode(key), '=',
      options.raw ? value : encode(value),
      options.expires ? '; expires=' + options.expires.toUTCString() : '',
      options.path ? '; path=' + options.path : '',
      options.domain ? '; domain=' + options.domain : '',
      options.secure ? '; secure' : ''
    ].join(''))
  }

  // Key and possibly options given, get cookie
  options = value || {}

  return (result = new RegExp('(?:^|; )' + encode(key) + '=([^;]*)')
    .exec(document.cookie)) ? decode(result[1]) : null;
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var utils = __webpack_require__(5);
var es = __webpack_require__(0);
var tcss = __webpack_require__(6);
var Performance = __webpack_require__(1);

var
  // url = '//utherapitest.browser.qq.com/qbweb/report',
  url = '//utherapi.browser.qq.com/qbweb/report',
  win = window,
  doc = document,
  ext = win.external,
  encode = win.encodeURIComponent;

var default_conf = {
  protocol : 8888,
  key      : 0,
  v1       : 0,
  v2       : 0,
  v3       : 0,
  s1       : '',
  s2       : '',
  s3       : '',
  // ---------------------------------------------------------------------------
  // 产品名称，默认为当前域名
  pname    : location.hostname,
  // 当为 true 时，v 和 s 的默认设定分别都为 0 和空字符串
  isCustom : false,
  tcss     : false,
  // 默认自动发送 pv
  autopv   : true,
  // 默认自动页面性能上报
  autoPerformance: true
};

function WSD (conf) {
  if (!(this instanceof WSD)) return new WSD(conf);
  this.setting(conf);
  this._initS2Obj();

  if (this.conf.autopv && !this.conf.isCustom) {
    this.pv();
  }
}

WSD.default_conf = default_conf;

WSD.prototype = {

  setting: function (conf) {
    if (!this.conf) this.conf = default_conf;
    this.conf = es.extend({}, this.conf, conf);
  },

  pv: function (pname) {
    this.track({v2: 1, s1: utils.getGuid(), s3: pname || this.conf.pname});
    if (this.conf.tcss) tcss.pv();
  },

  // key 值形式参考点击流： a.b.c.d
  click: function (key) {
    this.track({v2: 2, s1: utils.getGuid(), s3: key || ''});
    if (this.conf.tcss) tcss.click(key);
  },

  performance: function (pname) {
    if (!win.performance) return;
    // 性能相关的 key 取值范围 [1000, 1099]
    // 1001 为 performance.timing 相关的监控
    var self = this;
    utils.onLoadEventEnd(function () {
      self.track({key:1001, v2: 3,
        s1: es.stringify(Performance()), s3: pname || self.conf.pname});
    });
  },

  // First Screen
  fs: function (time, pname) {
    this.track({key:1002, v2: 4, v1: time, s3: pname || this.conf.pname});
  },

  track: function (opts, fn1, fn2) {

    var self = this, conf = self.conf,
      o = es.extend({}, conf, opts);

    // 尘归尘土归土，该 number or string 的一个都不能错，key 也得必须指定
    if (!es.inum(o.protocol, o.key, o.v1, o.v2, o.v3)
      || !es.istr(o.s1, o.s2, o.s3) || o.key <= 0) {
      return es.isFunction(fn2) && fn2(o);
    }

    if (!o.isCustom && o.protocol === 8888) {
      // v3 用于区分 QB or not QB
      // 为什么是数字 96，因为外形上看起来像小写的 qb
      // 为什么是 69，因为 96 反过来或倒过来就是 69 啊
      o.v3 = utils.isQB ? 96 : 69;
      // s2 默认值
      if (!o.s2) o.s2 = es.stringify(self.s2obj)
    }

    if (utils.isQB && ext && ext.dataReport) {
      try {
        // 第三个参数为上报类型： 0-实时，1-退出累计，2-退出非累计
        ext.dataReport(o.protocol, o.key, 0, o.v1, o.v2, o.v3, o.s1, o.s2, o.s3);
        es.isFunction(fn1) && fn1(o)
      } catch (e) {
        win.console && console.error(e);
        es.isFunction(fn2) && fn2(o);
        // todo 是否应该尝试下 _notQBTrack ?
      }
    } else {
      encodeS123(o);
      self._notQBTrack(o, fn1, fn2);
    }
  },

  _notQBTrack: function (conf, fn1, fn2) {
    var str = [
      '_ApplicationId=qbweb',
      'stComm=' + es.stringify({sGuid: utils.getGuid()}),
      'vProtocols_Function=' + es.stringify([{
         iProtocol : conf.protocol,
         iKey      : conf.key,
         iValueI   : conf.v1,
         iValueII  : conf.v2,
         iValueIII : conf.v3,
         sValueI   : conf.s1,
         sValueII  : conf.s2,
         sValueIII : conf.s3
      }])
    ].join('&');

    utils.imgsend(url + '?' + str, function () {
      es.isFunction(fn1) && fn1(o);
    }, function () {
      es.isFunction(fn2) && fn2(o);
    });
  },

  _initS2Obj : function () {
    this.s2obj = {
      'name' : this.conf.pname,
      'id'   : utils.getGuid(),
      'ua'   : navigator.userAgent,
      'url'  : location.href,
      'ref'  : doc.referrer,
      't'    : (new Date).getTime(),
      'w'    : screen.width,
      'h'    : screen.height,
      'vw'   : win.innerWidth || doc.documentElement.clientWidth || 0,
      'vh'   : win.innerHeight || doc.documentElement.clientHeight || 0,
      'dpr'  : win.devicePixelRatio || 1,
      'tag'  : utils.getUrlParams('ADTAG') || ''
    };
  }
};

function encodeS123 (obj) {
  obj.s1 = encode(obj.s1);
  obj.s2 = encode(obj.s2);
  obj.s3 = encode(obj.s3);
  return obj
}

module.exports = WSD;


/***/ }),
/* 10 */
/***/ (function(module, exports) {


var isFunction = function (obj) {
  return Object.prototype.toString.call(obj) === "[object Function]";
}

var doc = document,
  win = window,
  head = doc.head || doc.getElementsByTagName("head")[0],
  baseElement = head.getElementsByTagName("base")[0];

var requirejs = function (urls, callback, errorCallback) {

  if (urls.length === 0) {
    return isFunction(callback) && callback();
  }

  var url = urls.shift(),
    node = doc.createElement("script");

  node.charset = 'utf-8';

  if ("onload" in node) {
    // node.onload = node.onerror = onload;
    node.onload = onload;
    node.onerror = errorCallback
  } else {
    node.onreadystatechange = function() {
      if (/loaded|complete/.test(node.readyState)) {
        onload();
      }
    }
  }

  function onload() {
    win.console && console.log('> script loaded: ', node.src);
    // Ensure only run once and handle memory leak in IE
    node.onload = node.onerror = node.onreadystatechange = null;
    // Remove the script to reduce memory leak
    // head.removeChild(node);
    // Dereference the node
    node = null;

    if (urls.length) {
      requirejs(urls, callback);
    } else {
      // console.log('scripts load finish!');
      isFunction(callback) && callback();
    }
  }

  node.async = "async";
  node.src = url;

  // ref: #185 & http://dev.jquery.com/ticket/2709
  baseElement ?
    head.insertBefore(node, baseElement) :
    head.appendChild(node);
};

module.exports = requirejs


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// qblog-0.1.2.js